import { login, oneTimeTokenLogin } from "helpers/auth-service";
import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { UxLoading } from "@imaginelearning/mps-ux-component-library";
import { sessionStorageKeys } from "../../imagineplus-assessments/types";
import useStudentAuth from "./useStudentAuth";

interface QueryParameters {
  okayToProceed: boolean;
  subject: string | undefined;
  target: string | undefined;
  diagnostic: string | undefined;
  returnUrl: string | undefined;
  ott: string | undefined;
}

function extractQueryParameters(search: string) {
  const query = new URLSearchParams(search);

  let okayToProceed = false;
  let subject: string | undefined;
  let target: string | undefined;
  let diagnostic: string | undefined;
  let returnUrl: string | undefined;
  let ott: string | undefined;

  query.forEach((value, key) => {
    switch (key.toLowerCase()) {
      case "subject":
        subject = value;
        break;
      case "target":
        target = value;
        break;
      case "diagnostic":
        diagnostic = value;
        break;
      case "ott":
        ott = value;
        break;
      case "returnurl":
        returnUrl = decodeURIComponent(value);
        break;
      case "appfrom":
        if (value.toLowerCase() === "mpp") {
          okayToProceed = true;
        }
        break;
      // no default
    }
  });
  return { okayToProceed, subject, target, diagnostic, returnUrl, ott };
}

function SignIn() {
  const { search } = useLocation();
  const { logStudentIn } = useStudentAuth();

  useEffect(() => {
    const { okayToProceed, subject, target, diagnostic, returnUrl, ott }: QueryParameters =
      extractQueryParameters(search);

    if (okayToProceed) {
      if (subject) {
        sessionStorage.setItem("target", "MyPath");
        sessionStorage.setItem("landingSubject", subject);
        login();
      } else if (target?.toLowerCase() === "ipa") {
        sessionStorage.setItem("target", "I+A");

        if (diagnostic) {
          sessionStorage.setItem(sessionStorageKeys.diagnosticSubject, diagnostic);
        } else {
          sessionStorage.removeItem(sessionStorageKeys.diagnosticSubject);
        }

        if (returnUrl) {
          sessionStorage.setItem(sessionStorageKeys.referrer, "L&L");
          sessionStorage.setItem(sessionStorageKeys.returnUrl, returnUrl);
        }

        if (ott) {
          oneTimeTokenLogin(ott)
            .then(async ({ accessToken, refreshToken }: { accessToken: string; refreshToken: string }) => {
              sessionStorage.setItem(sessionStorageKeys.oneTimeToken, "true");
              await logStudentIn(accessToken, refreshToken);
            })
            .catch(() => {
              // if we fail to redeem the one-time token for any reason, redirect the user to the login page
              login();
            });
        } else {
          login();
        }
      }
    }
  }, [logStudentIn, search]);

  return <UxLoading />;
}

export default SignIn;
